// extracted by mini-css-extract-plugin
module.exports = {"googleSingIn":"SignUp_googleSingIn__2JtCE"};